import React, { useState, useEffect } from 'react';

import { ReactComponent as LogoDM } from "assets/images/auth/logoDM.svg";
import { ReactComponent as LogoPP } from "assets/images/auth/logoPP.svg?v=1";
import { ReactComponent as LogoHC } from "assets/images/auth/logoHC.svg";
import { ReactComponent as LogoGPS } from "assets/images/auth/logoGPS.svg";
import { ReactComponent as LogoAPM } from "assets/images/auth/logoAPM.svg";

import * as Layout from '../styled';
import * as Styled from './styled';
import { useAllocatorAccess } from 'utils/utility';
import { ppURL, gmURL, hcURL } from 'Config/config';

const increaseBy = (num) => {
  let counter = num;
  return () => {
    const result = counter;
    counter += 50;
    return result;
  }
}

const Landing = () => {
  const animateDelayCounter = increaseBy(100);

  const [animate, setAnimate] = useState(false);

  const isAllocatorUser = useAllocatorAccess();

  useEffect(() => {
    setTimeout(() => {
      setAnimate(true);
    }, 100);
  }, []);

  return (
    <Layout.Screen $landing>
      <Styled.FormWrapper>
        <Layout.Title $animate={animate} $animateDelay={animateDelayCounter()} data-testid="welcome">Welcome to Arootah Apps!</Layout.Title>
        <Styled.Text $animate={animate} $animateDelay={animateDelayCounter()}>Choose the app where you want to log in.</Styled.Text>

        <Styled.AppsList>
          <Styled.AppLink href={gmURL} target="_blank" $animate={animate} data-testid="gps" $animateDelay={animateDelayCounter()}>
            <LogoGPS />
            <Styled.AppItemTitle>Goal Manager</Styled.AppItemTitle>
          </Styled.AppLink>

          <Styled.AppLink href={`${gmURL}/time-manager`} target="_blank" $animate={animate} data-testid="apm" $animateDelay={animateDelayCounter()}>
            <LogoAPM />
            <Styled.AppItemTitle>Time Manager</Styled.AppItemTitle>
          </Styled.AppLink>

          <Styled.AppLink href={hcURL} target="_blank" $animate={animate} data-testid="hc" $animateDelay={animateDelayCounter()}>
            <LogoHC />
            <Styled.AppItemTitle>Habit Manager</Styled.AppItemTitle>
          </Styled.AppLink>

          <Styled.AppLink href={`${ppURL}/${isAllocatorUser ? "allocator-tool" : "decision-manager"}`} target="_blank" data-testid="dm" $animate={animate} $animateDelay={animateDelayCounter()}>
            <LogoDM />
            <Styled.AppItemTitle>{isAllocatorUser ? "Allocator Tool" : "Decision Manager"}</Styled.AppItemTitle>
          </Styled.AppLink>

          <Styled.AppLink href={`${ppURL}/project-planner`} target="_blank" data-testid="pp" $animate={animate} $animateDelay={animateDelayCounter()}>
            <LogoPP />
            <Styled.AppItemTitle>Project Manager</Styled.AppItemTitle>
          </Styled.AppLink>
        </Styled.AppsList>
      </Styled.FormWrapper>
    </Layout.Screen>
  );
}

export default Landing;
